export const messages = {
    en: {
      run_bar: 'Want to join?',
      register: 'Register',
      see_offer: 'see the offer',
      run_bar_lunch: 'You serve lunches? Register your venue or sign in with Facebook.',
      place_owner: 'Place owner:',
      privacy_policy: 'Privacy policy',
      links: 'List of venues',
      warning_message_lunch: 'Welcome to {brand}! Find restaurants serving lunches near you',
      cookies: 'Information about Internet cookies',
      cookies_message: 'We use essential cookies for the site to work. Analytics cookies (Google Analytics) are used only if you consent in the privacy banner. You can change your choice anytime. More in our',
      place_count_message: 'Information about events or transmissions in {numberOfPlaces} places already available!',
      place_count_lunch_message: 'Information about lunches in {numberOfPlaces} places already available!',
      place_count_schedule_message: 'Class schedules from {numberOfPlaces} venues already available!',
      run_bar_schedule: 'Aggregated class schedules (yoga, dance, gym…) in one map.',
      schedule_time_from: 'Classes from',
      schedule_time_to: 'Classes to',
      schedule_day: 'Day',
      schedule_datetime_from: 'Classes from (date & time)',
      schedule_datetime_to: 'Classes to (date & time)',
      schedule_radius: 'Search radius',
      schedule_show_all_places: 'Show all venues (no radius)',
      schedule_show_list: 'Show list',
      schedule_hide_list: 'Show map',
      schedule_footer_hub: 'Class schedule',
      schedule_footer_terms: 'Terms',
      schedule_footer_privacy: 'Privacy policy',
      schedule_list_title: 'Matching venues & classes',
      schedule_list_empty: 'No venues match the current filters.',
      schedule_list_badge: 'Matching classes',
      schedule_show_more: 'Show more',
      i_understand: 'I understand',
      automatic_hiding: 'Automatic hiding',
      transmissions: 'Transmissions events',
      copy_link_message: 'Copy a link to this place and event.',
      copy_link_save_success: 'The link saved to the clipboard!',
      copy_link_save_failed: 'Failed to save the link to the clipboard.',
      day_schedule: 'Day schedule',
      all_schedule: 'All time schedule',
      ai_predicted: 'AI suggestion — not confirmed by the venue. Contact the pub to verify.',
      or_fill: 'or fill in the',
      offer: 'Offer',
      form: 'Form',
      search_event: 'Search for an event...',
      search_tag: 'Extra filter...',
      search_tags: 'Filter by tags...',
      filter_team_map: 'Filter map by {team}',
      filter_league_map: 'Filter map by {league}',
      search_location: 'Search for a location...',
      locate_me: 'Show my location',
      locating: 'Locating…',
      geolocation_failed: 'Could not get your location',
      contains_license: 'Public licence data for this league — not a guarantee for this match. Contact the pub.',
      lunch_info: 'Lunch menu at {name}',
      show_menu: 'Show lunch menu',
      like_place_save_success: 'Like place!',
      like_place_save_failed: 'Unlike place!',
      like_place_message: 'Like place',
      original_post: 'Link to original post',
      lunch_warning: 'Dear client, these menus may not always be up to date. Please be advised. We welcome you to check the restaurants website',
      no_posts_info: 'No lunch menu downloaded at the moment. We invite you to check the restaurants website for the current lunch menu',
      missing_menu: 'Missing current menu. Check out the places website!',
      place_link: 'Place website',
      or: 'or',
      post_added: 'Post added',
      menu_updated: 'Menu updated',
      lunch_full_page: 'Full restaurant page',
      show_menu_larger: 'Open larger view'
    },
    pl: {
      contains_license: 'Dane o licencji na ligę — nie gwarantują transmisji tego meczu. Skontaktuj się z pubem.',
      search_location: 'Szukaj lokalizacji...',
      locate_me: 'Pokaż moją lokalizację',
      locating: 'Ustalanie lokalizacji…',
      geolocation_failed: 'Nie udało się pobrać lokalizacji',
      search_event: 'Szukaj wydarzenia...',
      search_tag: 'Dodatkowy filtr...',
      search_tags: 'Filtruj po tagach...',
      filter_team_map: 'Filtruj mapę: {team}',
      filter_league_map: 'Filtruj mapę: {league}',
      form: 'Formularz',
      or_fill: 'albo wypełnij',
      offer: 'Oferta',
      run_bar: 'Chcesz dołączyć?',
      register: 'Zarejestruj się',
      see_offer: 'zobacz ofertę',
      run_bar_lunch: 'Serwujecie lunche? Zarejestrujcie lokal albo zalogujcie się Facebookiem.',
      place_owner: 'Właściciel lokalu:',
      privacy_policy: 'Polityka prywatności',
      links: 'Lista lokali',
      warning_message_lunch: 'Witamy w {brand}! Znajdź restauracje serwujące lunche niedaleko Ciebie',
      cookies: 'Informacje o ciasteczkach',
      cookies_message: 'Używamy niezbędnych cookies do działania serwisu. Cookies analityczne (Google Analytics) włączamy dopiero po Twojej zgodzie w banerze prywatności. Wybór możesz zmienić w każdej chwili. Więcej w ',
      place_count_message: 'Informacje o wydarzeniach sprotowych i transmisjach w {numberOfPlaces} lokalach na stronie!',
      place_count_lunch_message: 'Informacje o lunchach w {numberOfPlaces} lokalach na stronie!',
      place_count_schedule_message: 'Grafiki zajęć z {numberOfPlaces} miejsc już na mapie!',
      run_bar_schedule: 'Zagregowane grafiki zajęć (joga, taniec, siłownia…) na jednej mapie.',
      schedule_time_from: 'Zajęcia od',
      schedule_time_to: 'Zajęcia do',
      schedule_day: 'Dzień',
      schedule_datetime_from: 'Zajęcia od (data i godzina)',
      schedule_datetime_to: 'Zajęcia do (data i godzina)',
      schedule_radius: 'Promień wyszukiwania',
      schedule_show_all_places: 'Pokaż wszystkie miejsca (bez promienia)',
      schedule_show_list: 'Pokaż listę',
      schedule_hide_list: 'Pokaż mapę',
      schedule_footer_hub: 'Harmonogram zajęć',
      schedule_footer_terms: 'Regulamin',
      schedule_footer_privacy: 'Polityka prywatności',
      schedule_list_title: 'Pasujące miejsca i zajęcia',
      schedule_list_empty: 'Brak miejsc dla wybranych filtrów.',
      schedule_list_badge: 'Pasujące zajęcia',
      schedule_show_more: 'Pokaż więcej',
      i_understand: 'Rozumiem',
      automatic_hiding: 'Chowaj automatycznie',
      transmissions: 'Transmituje wydarzenia',
      copy_link_message: 'Kopiuj link do miejsca i wydarzenia.',
      copy_link_save_success: 'Link został zapisany do schowka!',
      copy_link_save_failed: 'Nie udało się zapisać linku do schowka.',
      day_schedule: 'Dziejszy terminarz',
      all_schedule: 'Cały terminarz',
      ai_predicted: 'Sugestia AI — niepotwierdzona przez lokal. Skontaktuj się z pubem, aby upewnić się.',
      lunch_info: 'Lunch menu u {name}',
      show_menu: 'Pokaż lunch menu',
      like_place_save_success: 'Polub miejsce!',
      like_place_save_failed: 'Cofnij polubienie miejsca',
      like_place_message: 'Polub miejsce',
      original_post: 'Link do oryginalnego post',
      lunch_warning: 'Drodzy goście, lunch menu nie koniecznie zawsze jest na bieżąco. Proszę to mieć w pamięci. Zachęcamy do sprawdzenia na stronie restauracji',
      no_posts_info: 'Brak pobranego lunch menu na chwile obecna. Zapraszamy do sprawdzenia lunch menu na stronie restauracji',
      missing_menu: 'Brak aktualnego menu. Sprawdź na stronie lokalu!',
      place_link: 'Strona lokalu',
      or: 'albo',
      post_added: 'Post dodany',
      menu_updated: 'Aktualizacja menu',
      lunch_full_page: 'Pełna strona restauracji',
      show_menu_larger: 'Otwórz większy widok'
    }
  }
